/* eslint-disable max-len */
import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const modals = {
	searchClient: 'Vyhledání klienta',
	closeMessage: 'Opravdu chcete stránku opustit? Po potvrzení opustíte modální okno bez jakýchkoliv změn.',
};

export default Object.assign({}, modals, createLabeledMessages(modals));
